const skeletonPage = () => {

    function skeletonLoad(loadings) {
        loadings.forEach(function (element) {

            element.classList.add("skeleton-done");

            setTimeout(function () {
                element.classList.remove("skeleton-done");
                element.classList.remove("skeleton-1x");
                element.classList.remove("skeleton-2x");
                element.classList.remove("skeleton-3x");
                element.classList.remove("skeleton");
            }, 400)
        });
    }
    window.addEventListener("DOMContentLoaded", function () {
        var loadings = document.querySelectorAll(".skeleton");
        skeletonLoad(loadings);
    });
    window.addEventListener("DOMContentLoaded", function () {
        var loadings = document.querySelectorAll(".skeleton-1x,.skeleton-2x,.skeleton-3x");
        skeletonLoad(loadings);
    });

    window.addEventListener('DOMContentLoaded', function () {
        var skeleton = document.getElementById('Skeleton');
        if (skeleton) {
            skeleton.style.display = "none";
        }
        
    });

};

export {
    skeletonPage
};
